// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"505":"50c1083b","826":"554e4ecf","893":"2c03adf0"}[chunkId] + ".js";
};